import Form from './src/main';


export default Form;



// WEBPACK FOOTER //
// ./src/common/components/extend/form/index.js